export const pingForwarder = async (isAuthenticated) => {
  let isApiAvailable = false;

  if (!isAuthenticated) {
    return;
  }

  try {
    const response = await fetch("/stamp/ping-forwarder/", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error("pingForwarder: Network response was not ok");
    }
    const result = await response.json();
    isApiAvailable = result.success;
    console.log(isApiAvailable);
  } catch (error) {
    console.error("Error:", error);
  }
};
